import httpClient from '@/services/http/httpClient.ts'
import type { LoginResponse } from '@/services/http/httpResponses.ts'

// client_id OpenIddict-приложения. Дефолт совпадает с бэкендом Shagan (spa_app).
const oauthClientId = import.meta.env.VITE_OAUTH_CLIENT_ID || 'spa_app'

class AuthHttpService {
  public login(username: string, password: string) {
    return httpClient.post<LoginResponse>(
      '/api/connect/token',
      {
        grant_type: 'password',
        username: username,
        password: password,
        client_id: oauthClientId,
        scope: 'offline_access',
      },
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        withCredentials: true,
      },
    )
  }
  public logout() {
    return httpClient.get('/api/connect/logout')
  }
}

export default new AuthHttpService()
